export const CHURCH_ROLES = ["Pastor", "Treasurer", "Execom", "Church Board", "Member"];
export const roleName = (r) => (CHURCH_ROLES.includes(r) ? `${CHURCH_ROLES.indexOf(r) + 1}. ${r}` : r);

export const ROLE_LEVEL = {
  Pastor: "Level 1 · Full access + owner tools",
  Treasurer: "Level 1 · Full access",
  Execom: "Level 2 · Read-only, incl. financials",
  "Church Board": "Level 3 · Read-only, no financials",
  Member: "Level 4 · Own profile only",
};

export const canWrite = (user) => ["owner", "full"].includes(user?.access);
export const canSeeFinance = (user) => user?.access !== "read_nonfin";
export const isReadOnly = (user) => ["read_all", "read_nonfin"].includes(user?.access);
